import * as React from 'react'
import { IconButton } from '../../../app-core/lib/ui/IconButton'
import { ModalBottomSheet } from '../../../app-core/lib/ui/ModalBottomSheet'
import type { IconName } from '../../../shared/webcomponents/helpers/icons'
import classNames from 'classnames'

export type BottomSheetSize = 'small' | 'medium' | 'large' | 'auto'

export interface BaseBottomSheetProps {
    isOpen: boolean
    onClose: () => void
    title: string
    size?: BottomSheetSize
    onBack?: () => void
    noMargin?: boolean
    closeButtonTestId?: string
}

/** Wraps child content in a bottom sheet with title and close button */
export function BaseBottomSheet(props: React.PropsWithChildren<BaseBottomSheetProps>) {
    const modalProps = {
        size: props.size || 'medium',
        onClose: props.onClose,
        open: props.isOpen,
    }

    const actionButton = (iconName: IconName, onClick: () => void, testId?: string) => {
        return (
            <div className="AppCore__BaseBottomSheet-headerActions">
                <IconButton
                    className="AppCore__BaseBottomSheet-headerActions-button"
                    border={false}
                    iconName={iconName}
                    onClick={onClick}
                    size="small"
                    data-testid={testId}
                />
            </div>
        )
    }

    return (
        <ModalBottomSheet {...modalProps}>
            <div className="AppCore__BaseBottomSheet">
                <div className="AppCore__BaseBottomSheet-header">
                    {props.onBack ? (
                        actionButton('arrow-left', props.onBack)
                    ) : (
                        <div className="AppCore__BaseBottomSheet-headerSpacer" />
                    )}
                    <div className="AppCore__BaseBottomSheet-headerTitle">
                        <span>{props.title}</span>
                    </div>
                    {actionButton('cross', props.onClose, props.closeButtonTestId)}
                </div>
                <div
                    className={classNames(
                        'AppCore__BaseBottomSheet-content',
                        props.noMargin && 'AppCore__BaseBottomSheet-content--NoMargin'
                    )}
                >
                    {props.children}
                </div>
            </div>
        </ModalBottomSheet>
    )
}
